import "core-js/modules/web.url-search-params.delete.js";
import "core-js/modules/web.url-search-params.has.js";
import "core-js/modules/web.url-search-params.size.js";
import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createStaticVNode as _createStaticVNode } from "vue";
const _hoisted_1 = {
  class: "auth-callback"
};
const _hoisted_2 = {
  class: "callback-body"
};
const _hoisted_3 = {
  key: 0,
  class: "card"
};
const _hoisted_4 = {
  key: 1,
  class: "card"
};
const _hoisted_5 = {
  class: "desc"
};
import { ref, onMounted } from "vue";
import { useRoute } from "vue-router";
import { redirectToWxAuth } from "@/utils/wechat";
export default /*@__PURE__*/_defineComponent({
  __name: 'callback',
  setup(__props) {
    const route = useRoute();
    const status = ref("loading");
    const errorMessage = ref("授权凭证无效或网络异常，请重新进入应用。");
    onMounted(() => {
      if (route.query.error === "1") {
        status.value = "error";
      } else {
        status.value = "error";
        errorMessage.value = "页面访问方式不正确，请重新进入应用。";
      }
      // 清理 URL 中的残留授权参数
      const url = new URL(window.location.href);
      const authParams = ["code", "state", "accessToken", "authMode"];
      let changed = false;
      for (const key of authParams) {
        if (url.searchParams.has(key)) {
          url.searchParams.delete(key);
          changed = true;
        }
      }
      if (changed) {
        window.history.replaceState(window.history.state, "", url.toString());
      }
    });
    const retry = () => {
      redirectToWxAuth();
    };
    return (_ctx, _cache) => {
      const _component_van_button = _resolveComponent("van-button");
      return _openBlock(), _createElementBlock("main", _hoisted_1, [_cache[3] || (_cache[3] = _createElementVNode("div", {
        class: "callback-bg"
      }, null, -1)), _createElementVNode("div", _hoisted_2, [status.value === 'loading' ? (_openBlock(), _createElementBlock("div", _hoisted_3, _cache[0] || (_cache[0] = [_createElementVNode("div", {
        class: "loading-spinner"
      }, [_createElementVNode("div", {
        class: "spinner-ring"
      })], -1), _createElementVNode("p", {
        class: "loading-text"
      }, "正在完成登录...", -1)]))) : (_openBlock(), _createElementBlock("div", _hoisted_4, [_cache[2] || (_cache[2] = _createStaticVNode("<div class=\"error-icon\" data-v-e5b32688><svg viewBox=\"0 0 48 48\" width=\"56\" height=\"56\" data-v-e5b32688><circle cx=\"24\" cy=\"24\" r=\"22\" fill=\"none\" stroke=\"#ee0a24\" stroke-width=\"2.5\" data-v-e5b32688></circle><path d=\"M24 14v12\" fill=\"none\" stroke=\"#ee0a24\" stroke-width=\"2.5\" stroke-linecap=\"round\" data-v-e5b32688></path><circle cx=\"24\" cy=\"33\" r=\"1.5\" fill=\"#ee0a24\" data-v-e5b32688></circle></svg></div><h1 class=\"title\" data-v-e5b32688>登录未完成</h1>", 2)), _createElementVNode("p", _hoisted_5, _toDisplayString(errorMessage.value), 1), _createVNode(_component_van_button, {
        class: "retry-btn",
        block: "",
        round: "",
        color: "linear-gradient(135deg, #5282f0, #608df4)",
        onClick: retry
      }, {
        default: _withCtx(() => _cache[1] || (_cache[1] = [_createTextVNode(" 重新登录 ")])),
        _: 1
      })]))])]);
    };
  }
});